import React, { useState, useContext } from 'react'
import './RateAndReviewBox.css'
import { useNavigate, useLocation } from "react-router-dom";
import { callMultipleApis } from "../../services/ApiServices";
import { AuthContext } from "../../Context/AuthContext";


const submitReviewURL = process.env.REACT_APP_SUBMITREVIEW_URL;


const RateAndReviewBox = (props,) => {
    const { product, reviews, fetchProductReview } = props;
    const { userDetails } = useContext(AuthContext);

    const navigate = useNavigate();
    const location = useLocation();
    const [comment, setComment] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [rating, setRating] = useState(0);


    const submitReview = async () => {
        if (!rating || !comment.trim()) {
            alert("Please provide rating and comment");
            return;
        }

        const webtoken = localStorage.getItem("auth-token");

        const config = { 'Authorization': `Bearer ${webtoken}`, Accept: "application/json", };

        const data = { productid: product?.item_id, rating: rating, review: comment };

        const [response] = await callMultipleApis([
            {
                url: submitReviewURL,
                method: "POST",
                data: data,
                params: {},
                headers: config,
            }
        ]);

        if (response.statuscode == 403 || response.statuscode == 401) {
            alert(response.message);
        } else {
            if (response.status === true) {
                alert(response.message);
                setRating(0);
                setComment("");
                fetchProductReview();
            } else {
                alert(response.message);
            }

        }
    };

    return (
        <div className="reviews-section">
            <div className="reviews-container">

                {userDetails ? (
                    /* Write Review */
                    < div className="review-form">
                        <h3>Write a Review</h3>

                        <div className="star-rating">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    className={star <= rating ? "star active" : "star"}
                                    onClick={() => setRating(star)}
                                >
                                    ★
                                </span>
                            ))}
                        </div>

                        <textarea
                            placeholder="Share your experience with this product"
                            value={comment}
                            maxLength="500"
                            onChange={(e) => setComment(e.target.value)}
                        />

                        <button onClick={submitReview}>Submit Review</button>
                    </div>
                ) : (
                    <div className="review-form login-prompt">
                        <h3>Write a Review</h3>

                        <p>You must be logged in to submit a review.</p>

                        <button
                            onClick={() =>
                                navigate("/login", {
                                    state: {
                                        from: location.pathname + location.search,
                                    },
                                })
                            }
                        >
                            Login to write a review
                        </button>

                    </div>
                )
                }

                {/* Reviews List */}
                <div className="reviews-list">

                    <h3>Customer Reviews</h3>

                    {reviews.length === 0 ? (
                        <div className="no-reviews">
                            Review not found
                        </div>
                    ) : (
                        <> {reviews.map((r, i) => (
                            <div className="review-item" key={i}>
                                <div className="review-header">
                                    <span className="review-name">{r.full_name}</span>
                                    <span className="review-stars">
                                        {"★".repeat(r.rating)}
                                        {"☆".repeat(5 - r.rating)}
                                    </span>
                                </div>
                                <p>{r.review}</p>
                                <span className="review-date">
                                    {new Date(r.created_at).toDateString()}
                                </span>
                            </div>
                        ))}

                            {/* Pagination */}
                            <div className="pagination">
                                <button
                                    disabled={page === 1}
                                    onClick={() => setPage(page - 1)}
                                >
                                    Prev
                                </button>

                                <span>Page {page} of {totalPages}</span>

                                <button
                                    disabled={page === totalPages}
                                    onClick={() => setPage(page + 1)}
                                >
                                    Next
                                </button>
                            </div>

                        </>)}
                </div>
            </div>
        </div >
    )
}

export default RateAndReviewBox